import { render, staticRenderFns } from "./assign.vue?vue&type=template&id=dbfd52ce&scoped=true&"
import script from "./assign.vue?vue&type=script&lang=ts&"
export * from "./assign.vue?vue&type=script&lang=ts&"
import style0 from "./assign.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./assign.vue?vue&type=style&index=1&id=dbfd52ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfd52ce",
  null
  
)

export default component.exports